import type { RouteRecordRaw } from 'vue-router';
import { SETUP_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupAdminRoutes: RouteRecordRaw = {
  path: '/setup/admin',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: SETUP_ROUTE_NAME.ADMIN, path: '', component: () => import('./SetupAdmin.vue') },
  ],
};
